<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-md-12">
                <Card>
                    <div class="card-list-heading">
                        <h2 class="text-bold">{{ __('Shipments') }}</h2>

                        <div class="d-flex flex-wrap">
                            <button
                                @click="filter"
                                class="btn btn-md btn-primary mr-3"
                                type="button"
                            >
                                {{ __('Filter') }}
                            </button>

                            <button
                                @click="exportLoads"
                                class="btn btn-md btn-primary"
                                type="button"
                            >
                                {{ __('Export XLS') }}
                            </button>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12">
                         <div class="form-row-flex">
                        <span>
                            {{ __('Date from') }}
                        </span>
                        <DateTimePicker
                            :placeholder="__('Select')"
                            @change="formatDateFrom"
                            format="YYYY-MM-DD"
                            name="reportdatefrom"
                            type="date"
                            v-model="filters.dateFrom"
                            :max-date="filters.dateTo"
                            value-type="format"
                        />
                    </div>
                          
                            <div class="form-row-flex">
                                <span>
                                    {{ __('Receipt doc.') }}
                                </span>
                                   <!-- <FormInput
                                    type="text"
                                    v-model="filters.receiveDocument"
                                ></FormInput> -->
                                 <Autocomplete
                                    :fetch-callback="$api.autocomplete.shipmentsDocumentsDocuments"
                                    :placeholder="__('Select')"
                                    @input="(item) => filters.receiveDocument =item.label!=null?item.label:item"
                                    @selected="(item) => filters.receiveDocument = item.label"
                                    value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete>
                            </div>

                            <div class="form-row-flex">
                                <span>
                                    {{ __('Sender') }}
                                </span>
                                   <!-- <FormInput
                                   
                                
                                    type="text"
                                    v-model="filters.senderCustomer"
                                ></FormInput> -->
                               <Autocomplete
                                    :fetch-callback="$api.autocomplete.shipmentsDocumentsSenders"
                                    :placeholder="__('Select')"
                                    @input="(item) => filters.senderCustomer = item.label!=null?item.label:item"
                                    @selected="(item) => filters.senderCustomer = item.label"
                                    value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete>
                            </div>

                            <div class="form-row-flex">
                                <span>
                                    {{ __('Marking') }}
                                </span>
                                  <Autocomplete
                                    :fetch-callback="$api.autocomplete.shipmentsDocumentsMarks"
                                    :placeholder="__('Select')"
                                    @input="(item) => filters.marking = item.label!=null?item.label:item"
                                    @selected="(item) => filters.marking = item.label"
                                    value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete>
                                 <!-- <FormInput
                                    name="loads_marking"
                                 
                                    type="text"
                                    v-model="filters.marking"
                                ></FormInput> -->
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-12">
                         <div class="form-row-flex">
                        <span>
                            {{ __('Date to') }}
                        </span>
                        <DateTimePicker
                            :placeholder="__('Select')"
                            @change="formatDateTo"
                            format="YYYY-MM-DD"
                            name="reportdateto"
                            type="date"
                            v-model="filters.dateTo"
                            :min-date="filters.dateFrom"
                            value-type="format"
                        />
                    </div>      
                            <div class="form-row-flex">
                                <span>
                                    {{ __('Transport') }}
                                </span>
                                 <Autocomplete
                                    :fetch-callback="$api.autocomplete.shipmentsDocumentsTransports"
                                    :placeholder="__('Select')"
                                    @input="(item) => filters.transport = item.label!=null?item.label:item"
                                    @selected="(item) => filters.transport = item.label"
                                    value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete> 
                                   <!-- <FormInput
                                   
                                
                                    type="text"
                                    v-model="filters.transport"
                                ></FormInput> -->
                            </div>

                            <div class="form-row-flex">
                                <span>
                                    {{ __('Load title') }}
                                </span>
                                 <Autocomplete
                                    :fetch-callback="$api.autocomplete.shipmentsDocumentsShipments"
                                    :placeholder="__('Select')"
                                    @input="(item) => filters.shipment =item.label!=null?item.label:item"
                                    @selected="(item) => filters.shipment = item.label"
                                    value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete>
                                 <!-- <FormInput
                                   
                                
                                    type="text"
                                    v-model="filters.shipment"
                                ></FormInput> -->
                            </div>
                            <div class="form-row-flex">
                                <span>
                                    {{ __('Recipient') }}
                                </span>
                                <Autocomplete
                                    :fetch-callback="$api.autocomplete.shipmentsDocumentsReceivers"
                                    :placeholder="__('Select')"
                                    @input="(item) => filters.receiverCustomer = item.label!=null?item.label:item"
                                    @selected="(item) => filters.receiverCustomer = item.label"
                                    value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete> 
                                 <!-- <FormInput                                   
                                
                                    type="text"
                                    v-model="filters.receiverCustomer"
                                ></FormInput> -->
                            </div>
                           
                             <div class="form-row-flex">
                                <span>
                                    {{ __('LotNo') }}
                                </span>
                                 <!-- <FormInput
                                    name="loads_lotno"
                               
                                    type="text"
                                    v-model="filters.lotNo"
                                ></FormInput> -->

                                 <Autocomplete
                                    :fetch-callback="$api.autocomplete.shipmentsDocumentsLots"
                                    :placeholder="__('Select')"
                                    @input="(item) => filters.lotNo = item.label!=null?item.label:item"
                                    @selected="(item) => filters.lotNo = item.label"
                                    value-selector="label"
                                >
                                    <div slot-scope="result">
                                        {{ result.result.label }}
                                    </div>
                                </Autocomplete>

                                
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12 col-md-12 card-nopadding">
                            <wi-table
                                :default-params="{ sort: 'createdAt', order: 'desc'}"                              
                                :disable-search="true"
                                :disableHeader="true"
                                :fetch-callback="fetch"
                                ref="table"
                            >
                            
                                <wi-table-column
                                    class="text-nowrap"
                                    field="receiveDocument"
                                    sortable>
                                    {{ __('Receipt doc.') }}
                                </wi-table-column>
                                <wi-table-column   :render="(column) => moment(column.receiveDate).format('YYYY-MM-DD')" field="receiveDate">{{ __('Date of arrival') }}</wi-table-column>
                                <wi-table-column field="transport">{{ __('Transport') }}</wi-table-column>
                                <wi-table-column field="senderCustomer">{{ __('Sender') }}</wi-table-column>
                                <wi-table-column field="receiverCustomer">{{ __('Recipient') }}</wi-table-column>
                                <wi-table-column field="shipmentKind">{{ __('Load title') }}</wi-table-column>
                                <wi-table-column field="shipmentSize">{{ __('Size') }}</wi-table-column>
                                <wi-table-column field="marking">{{ __('Marking') }}</wi-table-column>
                                <wi-table-column field="lotNo">{{ __('LotNo') }}</wi-table-column>  
                                <wi-table-column field="producer">{{ __('Producer') }}</wi-table-column>
                                <wi-table-column field="produceDate">{{ __('Produce date') }}</wi-table-column>                                                        
                                <wi-table-column field="declaration">{{ __('Declaration') }}</wi-table-column>   
                                <wi-table-column field="weightDocumentBrutto">{{ __('BRUTTO weight DOC.') }}</wi-table-column>                        
                                <wi-table-column field="weightDocumentNetto">{{ __('NETTO weight DOC.') }}</wi-table-column>
                                <wi-table-column field="weightUnloadBrutto">{{ __('BRUTTO weight') }}</wi-table-column>
                                <wi-table-column field="weightUnloadNetto">{{ __('NETTO weight') }}</wi-table-column>                               
                                <wi-table-column field="stockQuantity">{{ __('Stock') }}</wi-table-column>
                                <wi-table-column field="weightStockBrutto">{{ __('BRUTTO weight stock') }}</wi-table-column>
                                <wi-table-column field="weightStockNetto">{{ __('NETTO weight stock') }}</wi-table-column>
                                
                                <template slot="actions" slot-scope="{ item }">
                                    <button
                                        class="btn btn-data-action ml-2"
                                        @click.prevent="attachmentsModal(item)"
                                    >{{ __('Attachments') }}
                                    </button>
                                </template>
                            </wi-table>
                        </div>
                    </div>
                </Card>
            </div>
        </div>
        <AttachmentsModal ref="modal"></AttachmentsModal>
    </div>
</template>

<script>
import moment from 'moment'
import AttachmentsModal from './AttachmentsModal'
import { FilterTable } from '@/mixins/FilterTable'

export default {
  name: 'Shipments',

    components: {AttachmentsModal},
    mixins: [ FilterTable ],
    data () {
      return {
        load: {
          dateFrom: null,
          dateTo:null,
          arrivalDate: null,
          transport: null,
          receiveDocument: null,
          shipment: null,
          senderCustomer: null,
          marking: null,
          receiverCustomer: null,
          state: null,
          lotNo:null,
        },moment
      }
  },

  methods: {

        formatDateFrom (date) {
      this.load.dateFrom = moment(date).format('YYYY-MM-DD')
      return this.load.dateFrom
    },

    formatDateTo (date) {
      this.load.dateTo = moment(date).format('YYYY-MM-DD')
      return this.load.dateTo
    },

    formatArrivalDate (date) {
      this.load.arrivalDate = moment(date).format('YYYY-MM-DD')
      return this.load.arrivalDate
    },
  
    exportLoads () {
      return this.$api.shipments.download(this.load)
    },

    fetch (params = []) {
      return this.$api.shipments.list(params)
    },

    dateFormat (item) {
      return moment(item.arrivalDate).format('YYYY-MM-DD')
    },

    attachmentsModal (item) {
      this.$refs.modal.show(item.id)
    },
  }
}
</script>
